import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
} from "@mui/material";
import { useState } from "react";
import type { JSX } from "react";

/** Create-a-priority modal. Resets its draft on close. Extracted from
 * `SettingsWorkflowsPanel.tsx`. */
export function NewPriorityDialog({
  isOpen,
  onClose,
  onSubmit,
  isSubmitting,
}: {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (b: { name: string; color?: string }) => void;
  isSubmitting: boolean;
}): JSX.Element {
  const [name, setName] = useState("");
  const [color, setColor] = useState("#f59e0b");

  const handleClose = () => {
    setName("");
    setColor("#f59e0b");
    onClose();
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!name.trim()) return;
    onSubmit({ name: name.trim(), color });
  };

  return (
    <Dialog open={isOpen} onClose={handleClose} maxWidth="xs" fullWidth>
      <DialogTitle>New priority</DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ fontSize: 14 }}>
          Urgency tier shown on the ticket header and used by SLA
          policies for routing and timers.
        </DialogContentText>

        <Box component="form" id="new-priority-form" onSubmit={handleSubmit} sx={{ mt: 2, display: "grid", gap: 1.5 }}>
          <TextField
            autoFocus
            label="Name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="High"
            fullWidth
          />
          <Box component="label" sx={{ display: "grid", gap: 0.5, fontSize: 14 }}>
            <Box component="span" sx={{ fontWeight: 500 }}>Colour</Box>
            <Box
              component="input"
              type="color"
              value={color}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => setColor(e.target.value)}
              sx={{ height: 36, width: 80, cursor: "pointer", borderRadius: 0.5, border: 1, borderColor: "divider", bgcolor: "background.default" }}
            />
          </Box>
        </Box>
      </DialogContent>

      <DialogActions>
        <Button
          type="button"
          variant="outlined"
          color="inherit"
          onClick={handleClose}
          disabled={isSubmitting}
        >
          Cancel
        </Button>
        <Button
          type="submit"
          variant="contained"
          form="new-priority-form"
          disabled={isSubmitting || !name.trim()}
        >
          Add priority
        </Button>
      </DialogActions>
    </Dialog>
  );
}
